export const ShareIcon = ({
  className,
  alt = "Share Icon",
}: {
  className?: string;
  alt?: string;
}) => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>{alt}</title>
      <circle
        cx="14.4817"
        cy="3.05386"
        r="2.00699"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle
        cx="14.4817"
        cy="15.6649"
        r="2.00699"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <circle
        cx="4.14727"
        cy="9.35943"
        r="2.63604"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <line
        x1="12.8545"
        y1="4.41946"
        x2="6.32428"
        y2="8.2537"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <line
        y1="-0.75"
        x2="7.57264"
        y2="-0.75"
        transform="matrix(-0.862341 -0.506328 -0.506328 0.862341 12.4747 14.946)"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};
